import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Meta from 'vue-meta'
Vue.use(Meta)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import ElementUI from 'element-ui'
// Element 额外提供了一系列类名，用于在某些条件下隐藏元素
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(ElementUI)

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

import uploader from 'vue-simple-uploader'
Vue.use(uploader)

import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards)

// 先引入 MathJax 配置, 再从 mathjax 包中引入 tex-mml-chtml
// 这里不使用 mathjax 的 npm 包, 而是使用 CDN 引入
import MathJax from './assets/js/mathjax'
// import 'mathjax/es5/tex-mml-chtml'
Vue.prototype.MathJax = MathJax

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import '@/permission'

// 全局配置 Message 的默认 duration 为 5000 毫秒（5秒）
Vue.use(ElementUI, {
  size: 'small',
  zIndex: 3000
})

// 单独为 Message 修改原型上的默认属性
Vue.prototype.$message = function(options) {
  if (typeof options === 'string') {
    options = { message: options }
  }
  // 默认加入 duration: 5000，如果传入了新值则覆盖默认值
  options.duration = options.duration === undefined ? 1000 : options.duration
  return ElementUI.Message(options)
};

// 挂载快捷方法（如 .warning, .success 等）
['success', 'warning', 'info', 'error'].forEach(type => {
  Vue.prototype.$message[type] = function(options) {
    if (typeof options === 'string') {
      options = { message: options }
    }
    options.type = type
    return Vue.prototype.$message(options)
  }
})

Vue.config.productionTip = false // 阻止控制台打印生产模式下的消息
Vue.prototype.baseURL = process.env.VUE_APP_SERVER_URL
new Vue({
  data: { // Bus总线
    // 自定义的事件总线对象，用于父子组件的通信
    Bus: new Vue()
  },
  render: h => h(App),
  router,
  store
}).$mount('#app')
